var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorGraphic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 418,
    viewBox: "0 0 670 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.914 254.563C245.234 254.563 302.24 197.577 302.24 127.281C302.24 56.9858 245.234 0 174.914 0C104.594 0 47.5884 56.9858 47.5884 127.281C47.5884 197.577 104.594 254.563 174.914 254.563Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30.561C0 76.8711 29.0626 114.345 64.9785 114.345L0 30.561Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9785 114.345C64.9785 67.5142 97.4108 29.6196 137.491 29.6196L64.9785 114.345Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.543 34.7593C23.543 78.7489 42.0757 114.345 64.9785 114.345L23.543 34.7593Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9785 114.345C64.9785 54.5058 102.465 6.08496 148.791 6.08496L64.9785 114.345Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3086 114.935C51.3086 114.935 60.5236 114.651 63.3008 112.675C66.078 110.698 77.4758 108.337 78.1647 111.508C78.8537 114.678 92.0132 127.276 81.6095 127.36C71.2058 127.444 57.4359 125.74 54.6641 124.052C51.8922 122.365 51.3086 114.935 51.3086 114.935Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M81.7952 126.257C71.3915 126.341 57.6216 124.637 54.8497 122.949C52.7388 121.664 51.8977 117.051 51.6162 114.923C51.4213 114.932 51.3086 114.935 51.3086 114.935C51.3086 114.935 51.8922 122.365 54.6641 124.053C57.4359 125.74 71.2058 127.444 81.6095 127.36C84.6126 127.336 85.65 126.268 85.593 124.686C85.1758 125.642 84.0304 126.239 81.7952 126.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.723 268.868C180.46 268.868 230.507 262.062 230.507 253.666C230.507 245.271 180.46 238.464 118.723 238.464C56.9867 238.464 6.93945 245.271 6.93945 253.666C6.93945 262.062 56.9867 268.868 118.723 268.868Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.724 266.43C170.556 266.43 212.574 260.715 212.574 253.667C212.574 246.618 170.556 240.903 118.724 240.903C66.8914 240.903 24.873 246.618 24.873 253.667C24.873 260.715 66.8914 266.43 118.724 266.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.103 417.698C593.533 417.698 669.273 407.398 669.273 394.692C669.273 381.986 593.533 371.686 500.103 371.686C406.673 371.686 330.933 381.986 330.933 394.692C330.933 407.398 406.673 417.698 500.103 417.698Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.674 399.549C241.798 399.549 287.295 393.361 287.295 385.729C287.295 378.096 241.798 371.909 185.674 371.909C129.55 371.909 84.0522 378.096 84.0522 385.729C84.0522 393.361 129.55 399.549 185.674 399.549Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.536 374.076C330.335 387.82 433.75 356.149 445.108 320.295",
    stroke: "#2F2E41",
    strokeWidth: 1.19513,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.076 154.77C185.076 154.77 262.787 133.257 267.569 202.575C272.351 271.892 203.607 291.612 257.407 305.356",
    stroke: "#2F2E41",
    strokeWidth: 1.19513,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.997 321.062C109.997 321.062 133.353 314.596 134.791 335.43C136.228 356.264 115.567 362.19 131.736 366.321",
    stroke: "#2F2E41",
    strokeWidth: 1.19513,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.489 336.573L460.78 366.627C460.78 366.627 437.598 378.939 453.898 379.301C470.198 379.663 546.991 379.301 546.991 379.301C546.991 379.301 561.843 379.301 538.298 366.265L533.589 334.762L465.489 336.573Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M450.619 378.975C454.321 375.682 460.781 372.251 460.781 372.251L465.49 342.196L533.589 342.26L538.298 371.889C543.789 374.929 547.19 377.259 549.18 379.047C552.204 378.357 555.508 375.794 538.298 366.265L533.589 334.762L465.49 336.573L460.781 366.627C460.781 366.627 441.3 376.974 450.619 378.975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.794 127.095H356.559C350.602 127.095 345.772 131.923 345.772 137.879V329.953C345.772 335.909 350.602 340.737 356.559 340.737H641.794C647.752 340.737 652.581 335.909 652.581 329.953V137.879C652.581 131.923 647.752 127.095 641.794 127.095Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.258 138.502H356.096V298.552H642.258V138.502Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.177 135.243C500.177 135.243 500.988 134.432 500.988 133.432C500.988 132.432 500.177 131.622 499.177 131.622C498.177 131.622 497.366 132.432 497.366 133.432C497.366 134.432 498.177 135.243 499.177 135.243Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.581 311.225V329.953C652.582 331.369 652.303 332.772 651.761 334.08C651.219 335.388 650.424 336.577 649.422 337.579C648.421 338.58 647.231 339.374 645.922 339.916C644.614 340.458 643.211 340.737 641.794 340.737H356.559C355.143 340.737 353.74 340.458 352.431 339.916C351.122 339.374 349.933 338.58 348.931 337.579C347.929 336.577 347.135 335.388 346.593 334.08C346.051 332.772 345.772 331.369 345.772 329.953V311.225H652.581Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.23 398.854V402.475H384.35V399.578L384.618 398.854L389.421 385.818H575.245L579.23 398.854Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.226 395.31C653.871 396.827 652.531 398.428 649.502 399.941C638.636 405.373 616.539 398.493 616.539 398.493C616.539 398.493 599.515 395.596 599.515 387.992C599.993 387.665 600.491 387.368 601.007 387.105C605.576 384.688 620.724 378.726 647.584 387.357C649.563 387.978 651.331 389.136 652.69 390.702C653.778 391.976 654.632 393.591 654.226 395.31Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M654.226 395.309C640.925 400.404 629.069 400.785 616.902 392.337C610.766 388.078 605.191 387.025 601.007 387.104C605.576 384.688 620.725 378.726 647.584 387.357C649.563 387.978 651.331 389.135 652.69 390.701C653.779 391.975 654.632 393.591 654.226 395.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.549 392.337C640.15 392.337 642.258 391.688 642.258 390.888C642.258 390.088 640.15 389.44 637.549 389.44C634.948 389.44 632.84 390.088 632.84 390.888C632.84 391.688 634.948 392.337 637.549 392.337Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.177 332.952C502.978 332.952 506.059 329.872 506.059 326.072C506.059 322.272 502.978 319.192 499.177 319.192C495.376 319.192 492.294 322.272 492.294 326.072C492.294 329.872 495.376 332.952 499.177 332.952Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M579.23 398.854V402.476H384.35V399.579L384.618 398.854H579.23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.261 95.0127H64.9238V239.624H189.261V95.0127Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.814 80.6714H52.3706V132.062H201.814V80.6714Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.814 141.623H52.3706V193.014H201.814V141.623Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.814 202.575H52.3706V253.965H201.814V202.575Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.925 89.6348H162.361V99.1958H171.925V89.6348Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M185.674 89.6348H176.109V99.1958H185.674V89.6348Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.423 89.6348H189.858V99.1958H199.423V89.6348Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.925 149.989H162.361V159.55H171.925V149.989Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M185.674 149.989H176.109V159.55H185.674V149.989Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.423 149.989H189.858V159.55H199.423V149.989Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.925 210.343H162.361V219.904H171.925V210.343Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M185.674 210.343H176.109V219.904H185.674V210.343Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.423 210.343H189.858V219.904H199.423V210.343Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.261 368.698C215.342 368.698 236.485 347.562 236.485 321.49C236.485 295.418 215.342 274.283 189.261 274.283C163.18 274.283 142.037 295.418 142.037 321.49C142.037 347.562 163.18 368.698 189.261 368.698Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.087 358.54H167.741V384.235H182.087V358.54Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.781 358.54H196.434V384.235H210.781V358.54Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.696 389.015C186.299 389.015 191.652 387.009 191.652 384.533C191.652 382.058 186.299 380.052 179.696 380.052C173.093 380.052 167.741 382.058 167.741 384.533C167.741 387.009 173.093 389.015 179.696 389.015Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.39 388.418C214.992 388.418 220.345 386.411 220.345 383.936C220.345 381.461 214.992 379.454 208.39 379.454C201.787 379.454 196.434 381.461 196.434 383.936C196.434 386.411 201.787 388.418 208.39 388.418Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.456 325.673C199.37 325.673 206.596 318.45 206.596 309.539C206.596 300.628 199.37 293.405 190.456 293.405C181.542 293.405 174.316 300.628 174.316 309.539C174.316 318.45 181.542 325.673 190.456 325.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.456 314.917C193.427 314.917 195.836 312.509 195.836 309.539C195.836 306.568 193.427 304.161 190.456 304.161C187.485 304.161 185.076 306.568 185.076 309.539C185.076 312.509 187.485 314.917 190.456 314.917Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.452 277.588C139.638 260.517 151.827 243.268 170.677 239.06C189.526 234.853 207.897 245.281 211.71 262.352C215.523 279.423 203.031 285.719 184.182 289.926C165.333 294.134 147.265 294.659 143.452 277.588Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.552 312.075C245.541 306.946 253.954 299.738 252.343 295.975C250.732 292.213 239.708 293.321 227.719 298.451C215.73 303.58 207.318 310.788 208.928 314.551C210.539 318.313 221.564 317.205 233.552 312.075Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.082 343.746C157.07 338.616 165.483 331.408 163.872 327.646C162.262 323.883 151.237 324.992 139.248 330.121C127.26 335.25 118.847 342.459 120.458 346.221C122.069 349.983 133.093 348.875 145.082 343.746Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.759 335.235C216.759 339.855 204.858 348.979 191.652 348.979C178.446 348.979 165.948 340.452 165.948 335.832C165.948 331.212 178.446 332.247 191.652 332.247C204.858 332.247 216.759 330.614 216.759 335.235Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 669.273,
    height: 417.698,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGraphic);
export default __webpack_public_path__ + "static/media/Error_Graphic.247bcf638e1240cc39f44d857befdeaf.svg";
export { ForwardRef as ReactComponent };